import {
  Typography,
} from '@mui/material'
import './prepared-documents-zip-button.scss'
import {
  useState,
} from 'react'
import {
  useTranslation,
} from 'react-i18next'
import {
  Button,
} from '@mui/material'

import {
  showApplicationPreparedDocumentsZipDownload,
} from '../check-block-utils'
import {
  downloadApplicationPreparedDocumentsZip,
} from '../download-application-document'

const PreparedDocumentsZipButton = ({ app, publicId, isManager = false }: ApplicationPreparedDocumentsZipButtonProps) => {
  const { t } = useTranslation()
  const [ loading, setLoading ] = useState(false)

  if (!showApplicationPreparedDocumentsZipDownload({ app: app, isManager: isManager })) {
    return null
  }

  const handleClick = () => {
    setLoading(true)
    downloadApplicationPreparedDocumentsZip(publicId)
      .catch(() => undefined)
      .finally(() => setLoading(false))
  }

  return (
    <div className='application-prepared-documents-zip-button'>
      <Button
        className='application-prepared-documents-zip-button'
        variant='outlined'
        disabled={loading}
        onClick={handleClick}
      ><Typography component='span' variant='inherit'>
          {t('applications__text__downloadAllDocumentsZip')}
        </Typography></Button>
    </div>
  )
}

export default PreparedDocumentsZipButton
